<template>
    <div class="card-header-block">
        <el-select v-model="type" @change="changeType" size="mini" style="width: 150px">
            <el-option v-for="item in typeList" :key="item.value" :label="item.text" :value="item.value"> </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name: "SelectChartValueType",
    data() {
        return {
            typeList: [
                { value: "1", text: "客流量（入园总数）" },
                { value: "2", text: "离园总数" },
                { value: "3", text: "在园总数" },
                { value: "4", text: "本周入园总数" },
                { value: "5", text: "本月入园总数" },
                { value: "6", text: "本年入园总数" },
            ],
            type: "1",
        };
    },
    methods: {
        changeType() {
            this.$emit("change", this.type);
        },
        change(v) {
            this.type = v;
        },
    },
};
</script>
